import * as React from 'react';

type Props = {
  filePreview: React.ReactNode;
};

function TranslationPreviewFiles({ filePreview }: Props) {
  return <div className="TranslationPreview-file-preview">{filePreview}</div>;
}

export { TranslationPreviewFiles, Props };
